<template>
  <div class="w-full h-full">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'public-home'
}
</script>
